import { formatDate } from "../../../../components/common/Converter";
import { upsertUseCase } from "../../../../usecases/object";

export default function emailBody(object, scheduleType, applicantObj) {
  console.log("OBJE: ", object);
  console.log("Schedule: ", scheduleType);
  const applicant = `${object?.firstName} ${object?.middleName} ${object?.surname}`;
  const personnelName = "Human Resource Development Division";
  const scheduleDate = object?.scheduleDate;
  const timeFrom = object?.timeFrom;

  const position = object?.positionTitle?.position_title;
  const zoomLink = object?.zoomLink;
  const passcode = object?.passcode;
  const deadline = object?.deadline;
  const deadlineTime = object?.deadlineTime;

  //   online exam
  const nameOne = object?.nameOne;
  const nameTwo = object?.nameTwo;
  const nameThree = object?.nameThree;
  const nameFour = object?.nameFour;
  const descriptionOne = object?.descriptionOne;
  const descriptionTwo = object?.descriptionTwo;
  const descriptionThree = object?.descriptionThree;
  const descriptionFour = object?.descriptionFour;

  //   F2F
  const location = object?.location;
  const venue = object?.venue;

  //   update Applicant
  const updateApplicant = async (applicantObj) => {
    await upsertUseCase().execute("job_applicants", applicantObj);
  };

  const header = () => {
    const template =
      scheduleType === "Online Exam"
        ? `NOTICE OF EXAMINATION (ONLINE EXAMINATION)`
        : scheduleType === "F2F Exam"
        ? `NOTICE OF EXAMINATION (FACE TO FACE)`
        : scheduleType === "Rejected"
        ? `NOTICE OF FAILURE`
        : `NOTICE OF INTERVIEW (ONLINE INTERVIEW)`;
    const content =
      scheduleType === "Online Exam"
        ? `ANNOUNCEMENT`
        : scheduleType === "Rejected"
        ? `EXAMINATION RESULTS`
        : `NOTICE`;

    const qualigication =
      scheduleType === "Online Interview"
        ? `ALL QUALIFIED APPLICANTS`
        : scheduleType === "Rejected"
        ? `ALL CONCERNED`
        : `ALL REGISTERED APPLICANTS`;
    return `
      <div class="header">${template}</div>
      <div class="content">
        <table>
          <tr>
            <td class="label">${content}</td>
          </tr>
          <tr>
            <td>
              <span class="label">TO : ${qualigication}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="label">FROM :</span> <span class="highlight">Chief, Human Resource Development Division</span><br>
            </td>
          </tr>
          <tr>
            ${
              scheduleType === "Online Exam"
                ? `
            <td>
              <span class="label">SUBJECT :</span> 
              <span class="highlight">SCHEDULE OF PRE-QUALIFICATION ONLINE EXAMINATION</span>
            </td>`
                : ""
            }
          </tr>
          <tr>
            ${
              scheduleType === "F2F Exam"
                ? `
            <td>
              <span class="label">SUBJECT :</span> 
              <span class="highlight">SCHEDULE OF PRE-QUALIFICATION EXAMINATION</span>
            </td>`
                : ""
            }
          </tr>
          <tr>
            <td>
              <span class="label">DATE :</span> <span class="highlight">${
                object?.scheduleDate ||
                object?.examDate ||
                formatDate(new Date())
              }</span>
              <hr/>
            </td>
          </tr>
        </table>
      </div>`;
  };

  const footer = () => {
    return `
        <div class="footer">
      ATTY. CRIS M. VILLALOBOS CHIEF<br>
      ${personnelName}
    </div>`;
  };

  const styles = () => {
    return `
    body {
      font-family: Arial, sans-serif;
    }
    .header {
      background-color: #ffcc00;
      text-align: center;
      padding: 10px;
      font-size: 18px;
      font-weight: bold;
    }
    .content {
      margin: 20px;
    }
    .label {
      font-weight: bold;
    }
    .highlight {
      font-weight: bold;
    }
    table {
      width: 100%;
      margin-top: 10px;
      border-collapse: collapse;
    }
    td {
      padding: 5px 10px;
    }
  .footer {
      margin-top: 40px;
      font-weight: bold;
      display: grid;
      justify-content: right;
    }

  .zoom-table {
      width: 60%;
      margin: 20px auto;
      border: 1px solid black;
      border-collapse: collapse;
    }
    .zoom-table td {
      border: 1px solid black;
      padding: 10px;
    }
    .position-table {
      width: 100%;
      margin-top: 20px;
    }
    .position-table td {
      text-align: center;
  }`;
  };

  switch (scheduleType) {
    case "Online Interview":
      applicantObj.location = `via Zoom: ${passcode}`;
      applicantObj.examDate = `${scheduleDate}`;
      updateApplicant(applicantObj);
      return `<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Notice of Interview</title>
  <style>
    ${styles()}
  </style>
</head>
<body>
  ${header()}
    <p>
      The Bureau of Immigration (BI) is pleased to announce the BI Online Pre-Qualifying Interview for the position of 
      <span class="highlight">${position}</span>, via <span class="highlight">online platform</span>.
    </p>

    <p>
      The online interview is scheduled on <span class="highlight">${scheduleDate}</span>.
      Kindly see attached file for your scheduled time of interview. Hence, you shall enter the Zoom Meeting Room Thirty (30) minutes 
      before your scheduled time of interview. Late comers will not be admitted to the meeting room.
    </p>

    <table>
      <tr>
        <td class="label">Zoom Meeting ID :</td>
        <td><span class="highlight">${zoomLink}</span></td>
      </tr>
      <tr>
        <td class="label">Passcode :</td>
        <td><span class="highlight">${passcode}</span></td>
      </tr>
    </table>

    <p>
      As a requirement, you shall submit a scanned copy of your Duly Notarized Personal Data Sheet (PDS) to 
      <span class="highlight">personnel@immigration.gov.ph</span>. Kindly rename the file with your Last Name, First Name, and Middle Initial.
      Deadline of submission will be on or before <span class="highlight">${deadline} at ${deadlineTime}</span>.
    </p>
    
    ${footer()}
</body>
</html>`;

    case "Online Exam":
      applicantObj.location = `via Zoom: ${passcode}`;
      applicantObj.examDate = `${scheduleDate}`;
      updateApplicant(applicantObj);
      return `
      <html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Notice of Interview</title>
  <style>
    ${styles()}
  </style>
</head>
<body>
  ${header()}
   <p>
      The Bureau of Immigration (BI) is pleased to announce the BI Pre-Qualifying Online Examination for all registered applicants for the following positions:
    </p>

    <table class="position-table">
      <tr>
        <td class="highlight">${nameOne}<br>${descriptionOne}</td>
        <td class="highlight">${nameTwo}<br>${descriptionTwo}</td>
      </tr>
      <tr>
        <td class="highlight">${nameThree}<br>${descriptionThree}</td>
        <td class="highlight">${nameFour}<br>${descriptionFour}</td>
      </tr>
    </table>

    <p>
      The online examination is scheduled on <span class="highlight">${scheduleDate}</span>. Applicants shall enter the Zoom Videoconference Waiting Room one (1) hour before your scheduled time of examination. Late comers will not be admitted. Furthermore, please find below details:
    </p>

    <table class="zoom-table">
      <tr>
        <td class="label">Zoom Meeting ID</td>
        <td class="highlight">${zoomLink}</td>
      </tr>
      <tr>
        <td class="label">Passcode</td>
        <td class="highlight">${passcode}</td>
      </tr>
    </table>

    <p>
      Kindly check attached files for the list of names of examinees and examination guidelines.
    </p>

    <p>Thank you.</p>
    ${footer()}
</body>
</html>
`;
    case "F2F Exam":
      applicantObj.location = `at the ${location} ${venue}`;
      applicantObj.examDate = `${scheduleDate}`;
      updateApplicant(applicantObj);
      return `
      <html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Notice of Interview</title>
  <style>
    ${styles()}
  </style>
</head>
<body>
      ${header()}
    <p>
      The Bureau of Immigration (BI) is pleased to announce the BI Pre-Qualifying Examination for all registered 
      <span class="highlight">${location}</span> applicants to be held at the <span class="highlight">${venue}</span>.
    </p>

    <p>
      The examination is scheduled on <span class="highlight">${scheduleDate}</span> from <span class="highlight">${timeFrom}</span>. 
      All registered applicants are encouraged to be at their assigned rooms at least ONE (1) HOUR before your scheduled time of examination 
      for registration and verification purposes. <span class="highlight">Late comers will not be admitted.</span>
    </p>

    <p>
      Kindly check the attached files for the list of names of examinees, examination guidelines and designated classroom numbers.
    </p>

    <p>Thank you.</p>
    ${footer()}
</body>
</html>`;
    case "Rejected":
      console.log("OBEJJCT: ", object);
      return `
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Notice of Interview</title>
  <style>
    ${styles()}
  </style>
</head>
<body>
      ${header()}
      <p>
      We regret to inform you that you <span class="highlight">FAILED</span> to qualify in the recently concluded Pre-Qualifying Examination held 
      <span class="highlight">${
        object?.location || ""
      }</span> last <span class="highlight">${
        object?.examDate || formatDate(new Date())
      }</span>.
    </p>

    <p>
      Thank you so much for your interest. You may check careers.immigration.gov.ph for future opportunities that may better fit your skills and experience.
    </p>

    <p>
      We wish you all the best in your job search and hope to consider you for another role in the future.
    </p>
    ${footer()}
</body>
</html>
`;
    default:
      return;
  }
}
